export const stageName = process.env.REACT_APP_ENV_STAGE_NAME || "LOCAL"

export const tenantID = process.env[`REACT_APP_${stageName}_KV_WEB_APP_TENANT_ID`]
export const clientID = process.env[`REACT_APP_${stageName}_KV_WEB_APP_CLIENT_ID`]
export const siteID = process.env[`REACT_APP_${stageName}_KV_WEB_APP_SITE_ID`]